import { render, staticRenderFns } from "./smsTemplateSet.vue?vue&type=template&id=3a4bc4bf&scoped=true&"
import script from "./smsTemplateSet.vue?vue&type=script&lang=js&"
export * from "./smsTemplateSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4bc4bf",
  null
  
)

export default component.exports